import EducatorSetup from './EducatorSetup';
import IframeWrapper from './IframeWrapper';

export default [
  EducatorSetup,
  IframeWrapper
];
